/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { StatusLabel } from "ui/StatusLabel";

import { EmptyHistory } from "../EmptyHistory";
import { HistoryCard } from "../HistoryCard";
import { historyStyle } from "./styles";

import type { Props } from "./props";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const HistoryList: FcWithoutChildren<Props> = ({ cards }) => {
  if (cards.length === 0) {
    return <EmptyHistory />;
  }

  return (
    <ul css={historyStyle}>
      {cards.map((card) => (
        <li key={card.linkTo}>
          <HistoryCard
            imagePath={card.imagePath}
            label={<StatusLabel status={card.shippingLabelStatus} />}
            linkTo={card.linkTo}
            orderId={card.orderId}
            paymentStatus={card.paymentStatus}
            paymentType={card.paymentType}
            purchasedAt={card.purchasedAt}
            purchasedCount={card.purchasedCount}
          />
        </li>
      ))}
    </ul>
  );
};
